module.exports = __webpack_public_path__ + "media/images/flags/ec-33ce56273543deb46e2cdb7663a89421.svg";